import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useIntl } from "react-intl";
import { ButtonCustom } from "../../../../components/sharedComponents/ButtonCustom";
import {
  dayTimeInMinutes,
  getMinutesFromTime,
} from "../../../../constants/constants";
import CalendarComponent from "../../../../components/sharedComponents/CalendarComponent";

export const BusyTimeModal = ({
  handleSubmit,
  onSubmit,
  selectedDate,
  setSelectedDate,
  register,
  watch,
  errors,
  setOpenCalendar,
  clearErrors,
  openCalendar,
  closeModal,
  vacation,
  setVacation,
  onDateSelect,
}) => {
  const [dates, setDates] = useState([]);

  const handleDateChange = () => {
    dates.map((d) => onDateSelect(d));
  };

  const isDateSelected = ({ date, view }) => {
    if (view !== "month") return false;

    return dates.some((selectedDate) => {
      return (
        selectedDate.toISOString().split("T")[0] ===
        date.toISOString().split("T")[0]
      );
    });
  };

  return (
    <form
      onSubmit={handleSubmit(() => {
        handleDateChange();
        closeModal();
      })}
      className="w-75 mx-auto"
    >
      <div className="mb-5">
        <CalendarComponent
          // selectedDate={dates[0]}
          setSelectedDate={(date) => {
            setDates((prev) => [...prev, date]);
          }}
          tileDisabled={() => openCalendar === "edit"}
          tileClassName={({ date, view }) =>
            view === "month" && isDateSelected({ date, view })
              ? "selected-date react-calendar__tile--active"
              : null
          }
        />
      </div>

      <div className="row mt-3">
        <div className="col-sm-6">
          <ButtonCustom className="w-100" text="Save" type="submit" />
        </div>
        <div className="col-sm-6">
          <ButtonCustom
            className="w-100 btn_dark"
            text="Decline"
            onClick={() => {
              clearErrors();
              closeModal();
            }}
          />
        </div>
      </div>
    </form>
  );
};
